/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2016 (original work) Open Assessment Technologies SA ;
 */
/**
 * This helper provides more statistics about the test
 *
 * @author Jean-Sébastien Conan <jean-sebastien.conan@vesperiagroup.com>
 */
define('taoQtiTest/runner/helpers/stats',[
    'lodash',
    'taoQtiTest/runner/helpers/map',
    'taoQtiTest/runner/helpers/currentItem'
], function (_, mapHelper, currentItemHelper) {
    'use strict';

    /**
     * Return scope stats that takes into account any test taker interaction made since the item has been loaded
     * @param {String} scope - scope to consider for calculating the stats
     * @param {Object} runner - testRunner instance
     * @returns {Object}
     */
    function getInstantStats(scope, runner) {
        var map = runner.getTestMap(),
            context = runner.getTestContext(),
            stats = _.clone(mapHelper.getScopeStats(map, context.itemPosition, scope)),

            isItemCurrentlyAnswered = currentItemHelper.isAnswered(runner);

        if (isItemCurrentlyAnswered){
            if (!isItemCurrentlyAnswered && context.itemAnswered) {
                stats.answered--;
            }

            if (isItemCurrentlyAnswered && !context.itemAnswered) {
                stats.answered++;
            }
        }
        return stats;
    }

    return {
        getInstantStats: getInstantStats
    };
});

